"use client"

import { useEffect, useState } from "react"
import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"

type AuthState = {
  accessToken: string
  refreshToken: string
  role: string
  username: string
  setSession: (s: { accessToken: string; refreshToken: string; role: string; username: string }) => void
  clear: () => void
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: "",
      refreshToken: "",
      role: "",
      username: "",
      setSession: (s) => set(s),
      clear: () => set({ accessToken: "", refreshToken: "", role: "", username: "" }),
    }),
    {
      name: "mxh-admin-auth",
      storage: createJSONStorage(() => localStorage),
    }
  )
)

// zustand persist 从 localStorage 水合完成前 accessToken 为空，
// 直接跳登录会误伤刷新/直达场景，守卫需等水合完成。
export function useAuthHydrated() {
  const [hydrated, setHydrated] = useState(() =>
    typeof window === "undefined" ? false : useAuth.persist.hasHydrated()
  )
  useEffect(() => {
    const unsub = useAuth.persist.onFinishHydration(() => setHydrated(true))
    setHydrated(useAuth.persist.hasHydrated())
    return unsub
  }, [])
  return hydrated
}
